// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/icons/Search.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tabs-container {
  display: flex;
}

.tab {
  padding: 15px;
  text-align: center;
  cursor: pointer;
  position: relative;
  font-size: 18px;
  font-weight: 400;
  font-family: "Barlow";
  color: rgb(125, 119, 121);
}

.btn-search {
  background-color: #FB263B;
  border: none !important;
  padding: 12px auto;
  border-radius: 0 2px 2px 0;
  width: 15%;
}

.search {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: 90% center;
  padding-left: 30px;
}

.search:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 20px;
  height: 20px;
  background-color: #f00;
  opacity: 0.5;
}

.underline {
  height: 2px;
  width: 0;
  background-color: #FB263B; /* Set your desired underline color */
  position: absolute;
  bottom: 0;
  transition: width 0.3s ease;
}

.border-tabs {
  border-bottom: 1px solid rgb(240, 237, 238);
  width: fit-content !important;
}

.tab.active {
  border-bottom: 5px solid #FB263B;
  padding-bottom: 10px;
  color: #FB263B;
  font-weight: 600;
}

.pagination {
  justify-content: center;
}
.pagination .active .page-link {
  background-color: #FB263B !important;
  border-radius: 20px !important;
  margin-right: 5px !important;
  border: none !important;
  color: #fff !important;
  box-shadow: none !important;
}
.pagination .page-link, .pagination .page-link-first, .pagination .page-link-last {
  color: #FB263B !important;
  background-color: transparent !important;
  border: none !important;
  margin-right: 5px !important;
  padding: var(--bs-pagination-padding-y) var(--bs-pagination-padding-x);
}
.pagination .page-link:hover {
  background-color: rgb(253, 230, 232) !important;
  border-radius: 20px !important;
  margin-right: 5px !important;
  border: none !important;
  color: #FB263B !important;
  box-shadow: none !important;
}
.pagination .page-link:focus {
  background-color: rgb(249, 194, 199) !important;
  border-radius: 20px !important;
  margin-right: 5px !important;
  border: none !important;
  color: #FB263B !important;
  box-shadow: none !important;
}

.slick-slider {
  width: 80%;
  margin: auto;
}

.slick-prev,
.slick-next {
  font-size: 24px;
}

.aug-thum {
  border: 1px solid rgb(234, 234, 234) !important;
  margin: 10px !important;
  padding: 20px !important;
}
.aug-thum .aug-img {
  width: 80%;
}

.thumbnail-wrapper {
  margin-right: 10px; /* Adjust as needed for spacing between thumbnails */
  border: 1px solid rgb(234, 234, 234) !important;
  margin: 10px !important;
  padding: 10px !important;
}

.img-thumbnail {
  width: 500px !important;
  border: none !important;
}

.thumbnails-container {
  overflow-x: auto;
  white-space: nowrap;
}

.ref-txt {
  font-size: 14px;
  font-family: "Barlow";
  font-weight: 400;
  color: rgb(125, 119, 121);
}

.carousel-item.active {
  border: 1px solid rgb(234, 234, 234) !important;
}`, "",{"version":3,"sources":["webpack://./src/views/catalogue/catalogue.scss","webpack://./src/assets/styles/colors.scss"],"names":[],"mappings":"AACA;EACI,aAAA;AAAJ;;AAGE;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;EACC,gBAAA;EACD,qBAAA;EACA,yBAAA;AAAJ;;AAQA;EACI,yBCtBY;EDuBZ,uBAAA;EACA,kBAAA;EACA,0BAAA;EACA,UAAA;AALJ;;AAQE;EACE,yDAAA;EACA,4BAAA;EACA,+BAAA;EACA,kBAAA;AALJ;;AAQC;EACG,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,YAAA;AALJ;;AAOE;EACE,WAAA;EACA,QAAA;EACA,yBCjDY,EDiDqB,qCAAA;EACjC,kBAAA;EACA,SAAA;EACA,2BAAA;AAJJ;;AAME;EACE,2CAAA;EACA,6BAAA;AAHJ;;AAKE;EACC,gCAAA;EACA,oBAAA;EACA,cC7Da;ED8Db,gBAAA;AAFH;;AAIE;EACE,uBAAA;AADJ;AAEI;EACE,oCAAA;EACA,8BAAA;EACA,4BAAA;EACA,uBAAA;EACA,sBAAA;EACA,2BAAA;AAAN;AAEI;EACE,yBAAA;EACA,wCAAA;EACA,uBAAA;EACA,4BAAA;EACA,sEAAA;AAAN;AAEI;EACE,+CAAA;EACA,8BAAA;EACA,4BAAA;EACA,uBAAA;EACA,yBAAA;EACA,2BAAA;AAAN;AAEI;EACE,+CAAA;EACA,8BAAA;EACA,4BAAA;EACA,uBAAA;EACA,yBAAA;EACA,2BAAA;AAAN;;AAKE;EACE,UAAA;EACA,YAAA;AAFJ;;AAKE;;EAEE,eAAA;AAFJ;;AAIE;EACE,+CAAA;EACA,uBAAA;EACA,wBAAA;AADJ;AAEI;EACE,UAAA;AAAN;;AAGE;EACE,kBAAA,EAAA,oDAAA;EACA,+CAAA;EACA,uBAAA;EACA,wBAAA;AAAJ;;AAGE;EACE,uBAAA;EACA,uBAAA;AAAJ;;AAEE;EACE,gBAAA;EACA,mBAAA;AACJ;;AACC;EACC,eAAA;EACA,qBAAA;EACA,gBAAA;EACA,yBAAA;AAEF;;AACA;EACE,+CAAA;AAEF","sourcesContent":["@import '../../assets/styles/colors.scss';\n.tabs-container {\n    display: flex;\n  }\n  \n  .tab {\n    padding: 15px;\n    text-align: center;\n    cursor: pointer;\n    position: relative;\n    font-size:18px;\n     font-weight: 400; \n    font-family: 'Barlow';\n    color: rgba(125, 119, 121, 1);\n  }\n//   input.search{\n//     background-image: url('../../assets//icons/Search.svg');\n//     background-position: 90%;\n//     background-color: red;\n//     background-repeat: no-repeat;\n//   }\n.btn-search{\n    background-color: $primary-color;\n    border:none !important;\n    padding: 12px auto;\n    border-radius: 0 2px 2px 0;\n    width: 15%;\n\n}\n  .search {\n    background-image: url('../../assets//icons/Search.svg');\n    background-repeat: no-repeat;\n    background-position: 90% center;\n    padding-left: 30px;\n  }\n  \n .search:before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 20px;\n    height: 20px;\n    background-color: #f00;\n    opacity: 0.5;\n  }\n  .underline {\n    height: 2px;\n    width: 0;\n    background-color:$primary-color; /* Set your desired underline color */\n    position: absolute;\n    bottom: 0;\n    transition: width 0.3s ease;\n  }\n  .border-tabs{\n    border-bottom: 1px solid rgba(240, 237, 238, 1);\n    width: fit-content !important;\n  }\n  .tab.active {\n   border-bottom: 5px solid $primary-color;\n   padding-bottom: 10px;\n   color:$primary-color;\n   font-weight: 600;\n  }\n  .pagination{\n    justify-content: center;\n    .active .page-link{\n      background-color: $primary-color !important;\n      border-radius: 20px !important;\n      margin-right:5px !important;\n      border:none !important;\n      color: #fff !important;\n      box-shadow: none !important;\n    }\n    .page-link, .page-link-first, .page-link-last{\n      color: $primary-color !important;\n      background-color: transparent !important;\n      border: none !important;\n      margin-right:5px !important;\n      padding: var(--bs-pagination-padding-y) var(--bs-pagination-padding-x);\n    }\n    .page-link:hover{\n      background-color: rgba(253, 230, 232, 1) !important;\n      border-radius: 20px !important;\n      margin-right:5px !important;\n      border:none !important;\n      color: $primary-color !important;\n      box-shadow: none !important;\n    }\n    .page-link:focus{\n      background-color: rgba(249, 194, 199, 1) !important;\n      border-radius: 20px !important;\n      margin-right:5px !important;\n      border:none !important;\n      color: $primary-color !important;\n      box-shadow: none !important;\n    }\n\n    \n  }\n  .slick-slider {\n    width: 80%;\n    margin: auto;\n  }\n  \n  .slick-prev,\n  .slick-next {\n    font-size: 24px;\n  }\n  .aug-thum{\n    border :1px solid rgba(234, 234, 234, 1) !important;\n    margin: 10px !important;\n    padding: 20px !important;\n    .aug-img{\n      width: 80%;\n    }\n  }\n  .thumbnail-wrapper {\n    margin-right: 10px; /* Adjust as needed for spacing between thumbnails */\n    border :1px solid rgba(234, 234, 234, 1) !important;\n    margin: 10px !important;\n    padding: 10px !important;\n    \n  }\n  .img-thumbnail{\n    width: 500px !important;\n    border:none !important;\n  }\n  .thumbnails-container {\n    overflow-x: auto;\n    white-space: nowrap;\n }\n .ref-txt{\n  font-size: 14px;\n  font-family: \"Barlow\";\n  font-weight: 400;\n  color: rgba(125, 119, 121, 1);\n  \n}\n.carousel-item.active{\n  border :1px solid rgba(234, 234, 234, 1) !important;\n}\n// .h-300{\n//   min-height: 300px !important;\n// }\n \n","$primary-color: #FB263B;\n$primary-color-hover: #ED4E5C;\n$primary-color-press: #F499A1;\n$interaction-dark-bg:#fff;\n$hover-dark-bg:#D5D4D5;\n$press-dark-bg:#969596;\n$light-bg:#F5F5F7;\n$dark-bg:#2D2A2C;\n$text-color:#121010;\n$subText-color:#7D7779;\n$success:#7BBE6A;\n$error:#FF8A00;\n$input-bg:#FAFAFA;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
